import app from './app';
import view from './view';

const router = async (route) => {
  const content = document.getElementById('app-content');
  content.innerHTML = '';

  switch (route) {
    case '': {
      content.appendChild(view.landing());
      break;
    }

    case '#/dashboard': {
      content.appendChild(view.dashboard());
      break;
    }

    case '#/privacy-policy': {
      content.appendChild(view.privacyPolicy());
      break;
    }

    case '#/remove-account': {
      content.appendChild(view.removeAccount());
      break;
    }

    case '#/sign-in': {
      content.appendChild(view.signIn());
      break;
    }

    case '#/sign-out': {
      content.appendChild(view.signOut());
      break;
    }

    case '#/sign-up': {
      content.appendChild(view.signUp());
      break;
    }

    default: {
      content.appendChild(view.notFound());
    }
  }

  app.lib.i18n.render();
};

export default router;
